import { HxAccount } from '@outlook/hxcore_web';
import * as PIEAuth from 'owa-client-pie/lib/authentication.g';
import { addAuthenticatedAccount } from './accountManager';

// Attempts to get an authentication token and add the specified account
export async function authAndAddNewAccount(email: string): Promise<HxAccount | undefined> {
    const authResult = await PIEAuth.getAuthTokenForNewAccount(email);
    if (!authResult.successful) {
        return undefined;
    }

    return addAuthenticatedAccount(
        authResult.email,
        authResult.webAccountId,
        authResult.accessToken,
        authResult.expiresDurationSecondsSinceZero,
        authResult.isAad
    );
}
